import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=fae5bece&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=fae5bece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae5bece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fae5bece')) {
      api.createRecord('fae5bece', component.options)
    } else {
      api.reload('fae5bece', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=fae5bece&scoped=true&", function () {
      api.rerender('fae5bece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home.vue"
export default component.exports